import Auth from '../auth/Auth';
import CreditRangeInfo from '../models/CreditRangeInfo';
import CreditRangeReportData from "../models/CreditRangeReportData";
import { WebClient } from './WebClient'

class ApiCreditRange extends WebClient {
    async getCreditRangeInfo(): Promise<CreditRangeInfo | undefined> {
        const url = "/document/creditrange";

        return this.get(url, Auth.getAuthToken()).then(res => {
            if (res.status === 200) {
                return res.data || undefined;
            }
            return undefined;
        }).catch(() => { return undefined; });
    }

    async getOutOfRangeCustomers(): Promise<CreditRangeReportData[]> {
        const url = "/creditrange/report";

        return this.get(url, Auth.getAuthToken()).then(res => {
            if (res.status === 200) {
                return res.data || [];
            }
            return [];
        }).catch(() => { return []; });
    }
}

export default new ApiCreditRange();
